








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloMailSkin, AloMailSkin } from '@/models/alo/AloMailSkin';
import { toStringDictionary } from '@/utils/groupBy';
import { getDefaultAloMailSkinLg } from '@/models/alo/AloMailSkinLg';


@Component({
  name: 'EditBaseMailSkin',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseMailSkin extends Vue {
  
  private original:AloMailSkin = getDefaultAloMailSkin()
  private modified:AloMailSkin = getDefaultAloMailSkin()
  private showDrawer = false
  private saving = false
    
  edit(item:AloMailSkin, addMissingLang = false) {
    this.$store.myActions.ADM_MAIL_SKIN_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloMailSkin(),...item}    
    this.modified = cloneDeep(this.original)

    if(addMissingLang) {
      //verification que toutes les langues sont bien présente on ajoute les manquantes
      const lgDic = toStringDictionary(this.modified.lgs,it => it.lg)
      this.configuration.langs.forEach(lg => {
        if(!lgDic[lg]) this.modified.lgs.push(getDefaultAloMailSkinLg(lg))
      })
    }

    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get mailSkinStatus() {
    return this.$store.myGetters.mailSkinStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_MAIL_SKIN_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.mailSkinStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
